<template>

</template>

<script>
export default {
    name    :   'AboutPage'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/AboutPage.vue